import { StudentDataConsentNameFragment } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: StudentDataConsentNameFragment) {
	return instance.id;
}

export const fieldLabels = {
	allowPublishVisualMediaOfStudentGeneral:
		"Publish student's photos and videos in the Verita portal newsletters and posts, share photos and videos from Google Drives and similar applications destined for the Verita community only.",
	allowPublishVisualMediaOfStudentForPromotion:
		"Publish student's photos and videos on social media, school's website, in brochures, and presentation materials with the purpose to promote Verita School's identity and values.",
	allowPublishStudentWorkGeneral:
		"Post the student's work and achievements (prizes, certificates, diplomas) on social media, on the school's website (student's name and photo may be shared as well).",
	allowPublishVisualMediaOfGuardianForPromotion:
		"Publish parents' school events photos and videos on social media, on the school website, in brochures and presentation materials to promote Verita School community, identity and values.",
	allowShareInformationWithPearsonEdexcel:
		"Transfer student's first name and last name, email, date of birth, gender to the Pearson Edexcel for IGCSE exams registration. (Applies only to students in years 9, 10, and 11).",
	allowShareInformationWithIbOrganization:
		"Transfer student's first name and last name, email, date of birth, gender, nationality, and languages to the International Baccalaureate Organization for IB exams registration. (Applies only to students in years 11, 12, and 13).",
	allowShareInformationWithOnlinePlatforms:
		"Transfer student's first name and last name, email, date of birth, gender, etc. to selected online platforms (free or purchased) to register for competitions or contests (such as Math and English) and for online courses that enhance the learning experience.",
	allowBirthdayInCalendar:
		"Share the student's birthday on the teacher's calendar (visible to teachers and staff only) to celebrate in class.",
	allowSendNewsletters:
		"Send you commercial newsletters (informative newsletters which are essential in establishing effective communication with the parents are not optional).",
	allowSendCalendarEvents: "Send you information and invitations to events organized by the school and our partners.",
};

export const summaryLabels = {
	allowPublishVisualMediaOfStudentGeneral: "Images internally",
	allowPublishVisualMediaOfStudentForPromotion: "Images for promotion",
	allowPublishStudentWorkGeneral: "Share student work",
	allowPublishVisualMediaOfGuardianForPromotion: "Parent images for promotion",
	allowShareInformationWithPearsonEdexcel: "Share with Pearson Edexcel",
	allowShareInformationWithIbOrganization: "Share with IB Organization",
	allowShareInformationWithOnlinePlatforms: "Share with online platforms",
	allowBirthdayInCalendar: "Birthday in calendar",
	allowSendNewsletters: "Commercial newsletters",
	allowSendCalendarEvents: "Event invites",
};
